import React, { createContext, useContext, useState } from 'react'
import { CaseAdversary } from '@/api/case'

type AdversariesDialogType = 'add' | 'edit' | 'delete'

interface AdversariesContextType {
    open: AdversariesDialogType | null
    setOpen: (open: AdversariesDialogType | null) => void
    currentRow: CaseAdversary | null
    setCurrentRow: (row: CaseAdversary | null) => void
}

const AdversariesContext = createContext<AdversariesContextType | undefined>(undefined)

export default function AdversariesProvider({ children }: { children: React.ReactNode }) {
    const [open, setOpen] = useState<AdversariesDialogType | null>(null)
    const [currentRow, setCurrentRow] = useState<CaseAdversary | null>(null)

    return (
        <AdversariesContext.Provider value={{ open, setOpen, currentRow, setCurrentRow }}>
            {children}
        </AdversariesContext.Provider>
    )
}

export const useAdversaries = () => {
    const context = useContext(AdversariesContext)
    if (!context) {
        throw new Error('useAdversaries must be used within an AdversariesProvider')
    }
    return context
}
